import { api } from "./api";

export const banksApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBanks: builder.query({
      query: () => "api/Fin/Banks",
      providesTags: ["banks"],
    }),
    addBank: builder.mutation({
      query: (formData) => ({
        url: "api/Fin/Banks",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["banks"],
    }),
    editBank: builder.mutation({
      query: (formData) => ({
        url: "api/Fin/Banks",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["banks"],
    }),
    deleteBank: builder.mutation({
      query: (bankId) => ({
        url: `api/Fin/Banks?BankID=${bankId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["banks"],
    }),
  }),
});

export const {
  useGetBanksQuery,
  useAddBankMutation,
  useEditBankMutation,
  useDeleteBankMutation,
} = banksApi;
